import { useState, useEffect } from 'react';
import axios from 'axios';
import { Star, Eye } from '@phosphor-icons/react';
import { useNavigate, Link } from 'react-router-dom';
import { Md } from '@/components/Md';
import { useRequireAdmin } from '@/hooks/useRequireAdmin';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ContentCasesPage() {
  useRequireAdmin();
  const [cases, setCases] = useState([]);
  const [tags, setTags] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try { const { data } = await axios.get(`${API}/api/admin/content-cases`); setCases(data); } catch {}
      try { const { data } = await axios.get(`${API}/api/patient-tags`); setTags(data?.tags || []); } catch {}
    })();
  }, []);

  return (
    <div className="fade-in" data-testid="content-cases-page">
      <div className="mb-5">
        <h2 className="font-heading font-medium text-xl text-brand-text">Casos para Conteúdo</h2>
        <p className="text-xs text-brand-muted mt-0.5">Pacientes sinalizadas como casos interessantes para partilha</p>
      </div>

      {cases.length === 0 ? (
        <div className="text-center py-16 bg-white border border-brand-border rounded-2xl">
          <Star size={48} className="mx-auto text-brand-placeholder mb-4" weight="duotone" />
          <p className="text-sm text-brand-muted">Nenhum caso sinalizado.</p>
          <p className="text-xs text-brand-placeholder mt-1">Activa o toggle "Caso interessante para conteúdo" na ficha de qualquer paciente.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {cases.map(c => (
            <div key={c.user_id} className="bg-white border border-brand-border rounded-2xl p-4" data-testid={`case-${c.user_id}`}>
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-sm font-medium text-brand-text">{c.name}</h3>
                  <p className="text-[10px] text-brand-muted mt-0.5">
                    {(c.patient_types || [c.patient_type]).filter(Boolean).map(v => tags.find(t => t.value === v)?.label || v).join(', ')}
                  </p>
                </div>
                <Link to={`/admin/pacientes/${c.user_id}`} className="text-brand-green hover:text-brand-green-hover p-1 inline-flex" title="Ver ficha" data-testid={`content-case-view-${c.user_id}`}><Eye size={16} /></Link>
              </div>
              {c.content_case_notes && <Md as="p" className="text-xs text-brand-muted mt-2 bg-brand-bg/30 rounded-xl p-2">{c.content_case_notes}</Md>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
